var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"mr-4"},[_vm._t("backButton")],2),_c('div',[_c('div',{staticClass:"text-body-1 font-weight-black"},[_vm._t("default")],2),_c('div',{staticClass:"text-body-2"},[_vm._t("subtitle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }